"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var _default = [{
  code: '18970',
  name: 'Photo Books',
  mobileName: 'Photo Books',
  url: '/photo-books',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 1,
  subCategories: null,
  enableDate: 1307752486239,
  disableDate: 0,
  linkedCategory: null,
  dynamicContentIds: {
    '0': ['photobooks_subnav_dropdown_about_cs', 'photobooks_subnav_dropdown_promo_cs']
  }
}, {
  code: '60000',
  name: 'Cards & Stationery',
  mobileName: 'Cards',
  url: '/cards-stationery',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 2,
  enableDate: 1305586365053,
  disableDate: 0,
  linkedCategory: null,
  dynamicContentIds: {
    '1': ['cs_subnav_dropdown_1x1', 'cs_subnav_dropdown_1x5'],
    '2': ['cs_subnav_dropdown_2x1', 'cs_subnav_dropdown_2x5']
  },
  subCategories: null
}, {
  code: '1096392',
  name: 'Prints',
  mobileName: 'Prints',
  url: '/prints',
  newCategoryTagEnabled: false,
  disabledOnMobile: false,
  rank: 3,
  enableDate: 1386008760000,
  hidden: false,
  disableDate: 0,
  linkedCategory: null,
  dynamicContentIds: {
    '0': ['prints_subnav_dropdown_printsposters_cs', 'prints_subnav_dropdown_promo_cs']
  },
  subCategories: null
}, {
  code: '1176213',
  name: 'Gifts',
  mobileName: 'Gifts',
  url: '/personalized-gifts',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 4,
  enableDate: 1456875660000,
  disableDate: 0,
  linkedCategory: null,
  subCategories: null,
  dynamicContentIds: {
    '1': ['photogifts_subnav_dropdown_seeall_cs', 'photogifts_subnav_dropdown_promo_cs'],
    '2': ['statementgifts_subnav_dropdown_seeall', 'statementgifts_subnav_dropdown_promo_cs']
  }
}, {
  code: '10014',
  name: 'Calendars',
  mobileName: 'Calendars',
  url: '/calendars',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 5,
  enableDate: 1322696340000,
  disableDate: 0,
  linkedCategory: null,
  subCategories: null,
  dynamicContentIds: {
    '0': ['calendars_subnav_dropdown_featured_cs', 'calendars_subnav_dropdown_promo_cs']
  }
}, {
  code: '1091982',
  name: 'Wall Art & Décor',
  mobileName: 'Wall Art & Décor',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 6,
  enableDate: 0,
  disableDate: 0,
  linkedCategory: null,
  url: '/home-decor',
  dynamicContentIds: {
    '1': ['homedecor_subnav_dropdown_1x1', 'homedecor_subnav_dropdown_1x5'],
    '2': ['homedecor_subnav_dropdown_2x1', 'homedecor_subnav_dropdown_2x5']
  },
  subCategories: null
}, {
  code: '1287500',
  name: 'Kids',
  mobileName: 'Kids',
  url: '/kids',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 8,
  enableDate: 1507791600000,
  disableDate: 0,
  linkedCategory: null,
  subCategories: null,
  dynamicContentIds: {
    '1': ['kids_subnav_1x1', 'kids_subnav_1x5'],
    '2': ['kids_subnav_2x1', 'kids_subnav_2x5']
  }
}, {
  code: '1237716',
  name: 'Wedding',
  mobileName: 'Wedding',
  url: '/wedding',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 7,
  enableDate: 1480834800000,
  disableDate: 0,
  linkedCategory: null,
  subCategories: null,
  dynamicContentIds: {
    '1': ['wedding_subnav_dropdown_1x1', 'wedding_subnav_dropdown_1x5'],
    '2': ['wedding_subnav_dropdown_2x1', 'wedding_subnav_dropdown_2x5']
  }
}, {
  code: '1085970',
  name: 'Deals',
  mobileName: 'Deals',
  url: '/special-offers',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 12,
  enableDate: 1365097320000,
  disableDate: 0,
  linkedCategory: null,
  dynamicContentIds: {
    '0': ['specialoffers_subnav_dropdown_photogifts_cs', 'specialoffers_subnav_dropdown_prints_cs']
  },
  subCategories: null
}, {
  code: '998',
  name: 'Ideas',
  mobileName: 'Ideas',
  url: '/ideas',
  newCategoryTagEnabled: false,
  hidden: false,
  disabledOnMobile: false,
  rank: 0,
  enableDate: 0,
  disableDate: 0,
  linkedCategory: null,
  dynamicContentIds: {
    '0': ['ideas_subnav_dropdown_featured_articles', 'ideas_subnav_dropdown_promo']
  },
  subCategories: null
}];
exports.default = _default;